import { Form, FormItemProps, RadioChangeEvent } from "antd";
import { CustomRadio, CustomRadioGroup } from "../../../Radio/index.styled";

interface RadioGroupFormProps extends FormItemProps {
  onChange?: (value: RadioChangeEvent) => void;
  readonly?: boolean;
}

export const RadioGroupForm: React.FC<RadioGroupFormProps> = ({
  onChange = () => void 0,
  readonly = false,
  ...props
}) => {
  const item = [
    { label: "가능해요", value: true },
    { label: "불가해요", value: false },
  ];

  return (
    <Form.Item {...props}>
      <CustomRadioGroup onChange={onChange} disabled={readonly}>
        {item.map(({ label, value }, index) => (
          <CustomRadio value={value} key={`radio:${props.name}:${index}`}>
            {label}
          </CustomRadio>
        ))}
      </CustomRadioGroup>
    </Form.Item>
  );
};
